import { Column, defaultColDef } from '@qrios/frontend-library';

import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'Operation Id',
    flex: 2
  },
  predefinedColumns.date({}),
  {
    ...defaultColDef,
    field: 'msisdn',
    headerName: 'Phone number',
    flex: 2
  },
  predefinedColumns.status({}),
  predefinedColumns.cost({})
];
